import React from 'react';
import styles from './styles/styles.module.css';
import { useDispatch, useSelector } from 'react-redux';
import {
  resetCurrentlyOpenLog,
  toggleDailyLogOpen,
  toggleProtecteeMovOpen,
} from '../../Redux/slices/bottomBarSlice';
import DailyLog from '../DailyLog/DailyLog';
import ProtecteeLog from '../ProtecteeLog/ProtecteeLog';

const BottomControllBar: React.FC = () => {
  const dispatch = useDispatch();
  const { currentlyOpenLog } = useSelector((state: any) => state.bottomBar);

  function toggle(e: any) {
    const icon = e.target.alt;
    switch (icon) {
      case 'logIcon':
        dispatch(toggleDailyLogOpen());
        //close all other windows
        break;
      case 'mov':
        dispatch(toggleProtecteeMovOpen());
        break;
      default:
        dispatch(resetCurrentlyOpenLog());
    }
  }

  function returnPopup() {
    switch (currentlyOpenLog) {
      case 'logIcon':
        return <DailyLog />;
      case 'mov':
        return <ProtecteeLog />;
      default:
        <></>;
    }
  }

  return (
    <>
      {returnPopup()}
      <div className={styles.wrapper}>
        <img
          draggable="false"
          onClick={toggle}
          className={styles.logIcon}
          alt="logIcon"
          src="./assets/logIcon.png"
        />
        {/* <img
          draggable="false"
          onClick={toggle}
          className={styles.logIcon2}
          alt="mov"
          src="./assets/protecteeMovements.png"
        /> */}
      </div>
    </>
  );
};

export default BottomControllBar;
